import { styled } from '@lingoda/ui/theme';
import { Avatar, Box } from '@lingoda/ui';
import { useSelector } from '@lingoda/hooks';
import { userSelector } from '@lingoda/auth';
import { useUserCreditsQuery } from '@lingoda/graphql';
import { hasSubscriptionSelector } from '@lingoda/subscriptions';
import { showToast } from '@lingoda/toasts';
import { StudentCreditsInfo } from '../../Credits/CreditsStore';
import { UserMenuItems } from '../../UserMenu';
import { Divider } from '../../MenuComponents';

const SidebarBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
});

interface Props {
    onClose: () => void;
}

export const SidebarNavigation = ({ onClose }: Props) => {
    const user = useSelector(userSelector);

    const { data } = useUserCreditsQuery({
        fetchPolicy: 'cache-and-network',
        onError: (error) => showToast('error', error.message),
    });
    const hasSubscription = useSelector(hasSubscriptionSelector);

    return (
        <SidebarBox>
            <Box sx={{ display: 'flex', alignItems: 'center' }} p={2} pb={0}>
                <Avatar size={40} src={user?.photo?.thumbnail}>
                    {user?.fullName}
                </Avatar>
                <Box fontWeight={600} ml={2}>
                    {user?.fullName}
                </Box>
            </Box>
            <StudentCreditsInfo
                onCTAClick={onClose}
                isLoading={!data} // show cached results while loading new ones
                hasSubscription={hasSubscription}
                {...data?.studentCreditsInfo}
            />
            <Divider />
            <UserMenuItems onClose={onClose} />
        </SidebarBox>
    );
};
